
import * as defaultImport from "lodash/some";
export * from "lodash/some";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
